import { GetAccountTopAppsMetricsSummaryRequestDto } from '../../../../src/interface/dtos/top-apps/get-account-top-apps-metrics-summary.request.dto';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountTopAppsMetricsSummaryApplicationService } from '../../../../src/core/application/services/top-apps/get-account-top-apps-metrics-summary.application-service';
import { AccountTopAppsMetricsSummaryAggregateRoot } from '../../../../src/core/domain/aggregates/top-apps/account-top-apps-metrics-summary.aggregate-root';

export class GetAccountTopAppsMetricsSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountTopAppsMetricsSummaryApplicationService
  ) {}

  async execute(
    props: GetAccountTopAppsMetricsSummaryRequestDto
  ): Promise<AccountTopAppsMetricsSummaryAggregateRoot[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new Error(
        `GetAccountTopAppsMetricsSummaryQuery.execute encountered an error ${error}`
      );
    }
  }
}
